import React, { useEffect, useState } from 'react'
import { Image, ImageBackground } from 'expo-image'
import { placeholderGeneral } from '../Constants'
import * as FileSystem from 'expo-file-system'
import { searchFile } from './ImageWIthZoom'

export const CachedImage = ({ uri, path, styles, useBackground = false }) => {
    const [image, setImage] = useState(null)

    useEffect(() => {
        if (!uri) {
            setImage(placeholderGeneral)
            return
        }
        if (!path || path.trim() === '') {
            setImage(uri)
            return
        }
        const fetchImage = async () => {
            let image = await searchFile(uri, path)
            setImage(image)
            // console.log('image :>> ', image)
        }
        fetchImage()
    }, [])

    if (image && useBackground) {
        return (
            <ImageBackground
                style={[styles, { overflow: 'hidden' }]}
                imageStyle={{ opacity: 0.3 }}
                source={image}
                contentFit='cover'
                blurRadius={3.5}
            >
                <Image style={styles} source={image} contentFit='contain' transition={1000} />
            </ImageBackground>
        )
    }
    return (
        <>
            {image && (
                <Image
                    style={styles}
                    source={image}
                    contentFit='contain'
                    transition={1000}
                    cachePolicy={'memory-disk'}
                    onError={(e) => {
                        setImage(placeholderGeneral)
                    }}
                />
            )}
        </>
    )
}
